import axios from "axios";
import { API_BASE_URL, APP_NUDGE_URL } from "config";
import { condition } from "context/condition";
import { Globalstate } from "context/context";
import { useMutation } from "react-query";

const getQna = async ({
  searchTerm,
  botKey,
  source,
  follow_up_flag,
  lang_code,
  nudgeFlow,
  signal,
}) => {
  const authToken = localStorage.getItem("authToken");

  let config = {
    method: "post",
    maxBodyLength: Infinity,
    url: nudgeFlow ? `${APP_NUDGE_URL}/nudge_qna` : `${API_BASE_URL}/qna`,
    headers: {
      Authorization: `Bearer ${authToken}`,
      "Content-Type": "application/json",
    },
    data: {
      query: searchTerm,
      model: process.env.REACT_APP_GPT_MODEL,
      source: source,
      follow_up_flag: follow_up_flag == true,
      lang_code: lang_code ? lang_code : "en-IN",
    },
    signal,
  };

  try {
    const data = await axios.request(config);
    return {
      data: {
        ...data.data,
        question: searchTerm,
        isBingResponse: false,
        userMessage: searchTerm,
      },
      key: botKey,
    };
  } catch (err) {
    if (
      axios.isCancel(err) ||
      err.name === "CanceledError" ||
      err.name === "AbortError"
    ) {
      console.log("❌ Request aborted by user");
      throw new Error("AbortError");
    }

    console.log("Error: ", err);
    return {
      data: {
        question: searchTerm,
        answer: "Something Went Wrong! Please Try Again Later",
        cta_results: [],
        recommended_questions: [],
        id: "",
        isBingResponse: false,
      },
      key: botKey,
    };
  }
};
/**
 * @description useQna is a custom hook used for asking query to the bot. This is used to make an api call to /qna. the result is then stored in the context. Destrcuture the mutuateAsync function from the hook and pass the value which we need to ask to the bot
 * @returns {function} useMutation function from react-query
 * @example
 * const {mutuateAsync} = useQna();
 * mutateAsync("hi");
 */
const useQna = () => {
  const { dispatch } = Globalstate();
  return useMutation(getQna, {
    onSuccess: (data) => {
      dispatch({
        type: condition.UPDATEMESSGES,
        payload: {
          key: data?.key,
          data: data.data,
        },
      });
      dispatch({
        type: condition.SETMESSAGESUBMITTED,
        payload: false,
      });
    },
    onError: (error) => {
      // Ignore AbortError to prevent showing fallback message
      if (error.message === "AbortError") return;

      dispatch({
        type: condition.UPDATEMESSGES,
        payload: {
          key: error?.key,
          data: error?.answer,
        },
      });
      dispatch({
        type: condition.SETMESSAGESUBMITTED,
        payload: false,
      });
    },
  });
};

export default useQna;
